import { createSlice } from "@reduxjs/toolkit";
import { fetchOriginsList, createOrUpdateOrigin, deleteOrigin } from "./originsThunks";

const originsSlice = createSlice({
  name: "origins",
  initialState: {
    origins: [],
    loading: false,
    error: null,
    successMessage: null,
    selectedOrigin: null,
    isEditOrigin: false,
  },
  reducers: {
    resetOriginManageStatus: (state) => {
      state.successMessage = null;
    },
    setSelectedOrigin: (state, action) => {
      state.selectedOrigin = action.payload;
    },
    setIsEditOrigin: (state, action) => {
      state.isEditOrigin = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchOriginsList.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchOriginsList.fulfilled, (state, action) => {
        state.loading = false;
        state.origins = action.payload;
      })
      .addCase(createOrUpdateOrigin.fulfilled, (state, action) => {
        state.successMessage = action.payload.message;
      })
      .addCase(deleteOrigin.fulfilled, (state, action) => {
        state.successMessage = action.payload.message;
      });
  },
});

export const { resetOriginManageStatus, setSelectedOrigin, setIsEditOrigin } = originsSlice.actions;
export default originsSlice.reducer;
